'use strict';

var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var slicedToArray = require('../../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var React = require('react');
require('prop-types');
var moment = require('moment');
var makeStyles = require('../../Styles/makeStyles.js');
var MenuItem = require('../../Navigation/Menus/MenuItem.js');
var Paper = require('../../Surfaces/Paper/Paper.js');
var ArrowDropdown = require('../../../IconsAndImages/Icons/ArrowDropdown.js');
var TextField = require('../TextFields/TextField.js');
var ObjectHelper = require('../../../common/ObjectHelper.js');
var downshift_esm = require('../../../node_modules/downshift/dist/downshift.esm.js');
var classNames = require('classnames');
var InputAdornment = require('../../../node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js');
var Popper = require('../../../node_modules/@material-ui/core/esm/Popper/Popper.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ENTER_KEY = 13;
var TAB_KEY = 9;
var TIME_FORMAT = 'h:mma';
var DATE_FORMAT = 'ddd, D MMM YYYY hh:mm:ss A';
var TIME_SLOTS = getTimeSlots();

function getTimeSlots() {
  var windows = [];

  for (var hour = 0; hour <= 23; hour++) {
    var hourToDisplay = hour % 12 == 0 ? 12 : hour % 12;
    var meridian = hour < 12 ? 'am' : 'pm';
    windows.push("".concat(hourToDisplay, ":00").concat(meridian));
    windows.push("".concat(hourToDisplay, ":30").concat(meridian));
  }

  return windows;
}

var useStyles = makeStyles["default"](function (theme) {
  return {
    container: {
      flexGrow: 1,
      position: 'relative'
    },
    paper: {
      position: 'absolute',
      zIndex: 1,
      marginTop: 0,
      left: 0,
      right: 0,
      height: 170,
      overflowY: 'scroll'
    },
    menuItem: {
      padding: '5px 12px',
      fontWeight: 400
    },
    selected: {
      fontWeight: 500
    },
    inputBackground: {
      backgroundColor: '#fce8e6 !important'
    },
    popper: {
      zIndex: theme.zIndex.modal
    },
    arrow: {
      color: theme.palette.secondary.main
    }
  };
});

var TimeSelectorTextsField = function TimeSelectorTextsField(_ref) {
  var onChange = _ref.onChange,
      date = _ref.date,
      dateError = _ref.dateError,
      inputId = _ref.inputId,
      enablePortal = _ref.enablePortal,
      variant = _ref.variant,
      margin = _ref.margin,
      disableUnderline = _ref.disableUnderline,
      label = _ref.label,
      disabled = _ref.disabled,
      showArrow = _ref.showArrow;

  var _useStyles = useStyles(),
      container = _useStyles.container,
      paper = _useStyles.paper,
      menuItem = _useStyles.menuItem,
      selected = _useStyles.selected,
      inputBackground = _useStyles.inputBackground,
      popper = _useStyles.popper,
      arrow = _useStyles.arrow;

  var _useState = React.useState(null),
      _useState2 = slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var _useState3 = React.useState(moment__default["default"](date, DATE_FORMAT).format(TIME_FORMAT)),
      _useState4 = slicedToArray(_useState3, 2),
      localTime = _useState4[0],
      setLocalTime = _useState4[1];

  React.useEffect(function () {
    setLocalTime(moment__default["default"](date, DATE_FORMAT).format(TIME_FORMAT));
  }, [date]);

  var originalOnChange = function originalOnChange(time) {
    var inputEl = document.getElementById(inputId);
    var newTime = moment__default["default"](time, TIME_FORMAT);
    var tempDate = date ? moment__default["default"](date, DATE_FORMAT) : moment__default["default"]();
    var newDate = tempDate.hour(newTime.hour()).minute(newTime.minute());
    setLocalTime(time);
    onChange(moment__default["default"](newDate.toDate(), moment__default["default"].ISO_8601).format());
    inputEl.blur();
  };

  var refs = {};
  TIME_SLOTS.forEach(function (slot) {
    return refs[slot] = React.useRef(null);
  });

  var timeWindows = function timeWindows(_ref2) {
    var getItemProps = _ref2.getItemProps,
        highlightedIndex = _ref2.highlightedIndex,
        inputValue = _ref2.inputValue;
        _ref2.selectedItem;
    var selectedSlot = TIME_SLOTS.find(function (slot) {
      return slot.startsWith(inputValue);
    });
    return TIME_SLOTS.map(function (slot, index) {
      var isHighlighted = highlightedIndex === index;
      var isSelected = slot === selectedSlot;
      var itemProps = getItemProps({
        item: slot
      });
      return React__default["default"].createElement("div", {
        ref: refs[slot],
        key: slot
      }, React__default["default"].createElement(MenuItem, _extends["default"]({}, itemProps, {
        value: slot,
        selected: isHighlighted,
        component: "div",
        classes: {
          root: classNames__default["default"](menuItem, defineProperty({}, selected, isSelected))
        }
      }), slot));
    });
  };

  var scrollToTime = function scrollToTime(time, setHighlightedIndex) {
    var selectedSlot = TIME_SLOTS.find(function (slot) {
      return slot.startsWith(time);
    });

    if (ObjectHelper.isPresent(selectedSlot)) {
      if (ObjectHelper.isPresent(setHighlightedIndex)) {
        setHighlightedIndex(TIME_SLOTS.indexOf(selectedSlot));
      }

      var selectedRef = refs[selectedSlot];

      if (ObjectHelper.isPresent(selectedRef) && ObjectHelper.isPresent(selectedRef.current)) {
        document.getElementById('scrolling_div').scrollTop = selectedRef.current.offsetTop - 40;
      }
    }
  };

  var handleCustomTimeKeyDown = function handleCustomTimeKeyDown(event, highlightedIndex, closeMenu) {
    switch (event.keyCode) {
      case ENTER_KEY:
        if (highlightedIndex === null) {
          closeMenu();
          originalOnChange(event.target.value);
        }

        break;

      case TAB_KEY:
        closeMenu();
        originalOnChange(event.target.value);
        break;
    }
  };

  var getInputValue = function getInputValue() {
    return localTime === 'Invalid date' ? '' : localTime;
  };

  var PopperComponent = enablePortal ? Popper : 'div';
  var popperComponentProps = {
    anchorEl: anchorEl,
    open: !!anchorEl,
    style: {
      width: anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.clientWidth
    },
    className: popper
  };
  return React__default["default"].createElement(downshift_esm["default"], {
    onStateChange: function onStateChange(changes) {
      if (changes.isOpen === true) {
        scrollToTime(localTime);
      }
    },
    inputValue: getInputValue(),
    onChange: originalOnChange,
    onOuterClick: function onOuterClick(event) {
      return originalOnChange(event.inputValue);
    }
  }, function (_ref3) {
    var getInputProps = _ref3.getInputProps,
        getItemProps = _ref3.getItemProps,
        getLabelProps = _ref3.getLabelProps,
        getMenuProps = _ref3.getMenuProps,
        isOpen = _ref3.isOpen,
        openMenu = _ref3.openMenu,
        closeMenu = _ref3.closeMenu,
        inputValue = _ref3.inputValue,
        highlightedIndex = _ref3.highlightedIndex,
        setHighlightedIndex = _ref3.setHighlightedIndex,
        selectedItem = _ref3.selectedItem;

    var _getInputProps = getInputProps({
      onFocus: openMenu,
      onKeyDown: function onKeyDown(event) {
        return handleCustomTimeKeyDown(event, highlightedIndex, closeMenu);
      },
      id: inputId
    }),
        onBlur = _getInputProps.onBlur,
        onFocus = _getInputProps.onFocus,
        onKeyDown = _getInputProps.onKeyDown,
        _onChange = _getInputProps.onChange,
        id = _getInputProps.id,
        inputProps = objectWithoutProperties(_getInputProps, ["onBlur", "onFocus", "onKeyDown", "onChange", "id"]);

    return React__default["default"].createElement("div", {
      className: container
    }, React__default["default"].createElement(TextField["default"], {
      fullWidth: true,
      margin: margin,
      variant: variant,
      label: label,
      inputProps: inputProps,
      InputProps: _objectSpread({
        className: dateError ? inputBackground : ''
      }, (!variant || variant === TextField.Variants.STANDARD.key || variant === TextField.Variants.FILLED.key) && {
        disableUnderline: disableUnderline
      }, {
        id: id,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        ref: setAnchorEl,
        onChange: function onChange(event) {
          _onChange(event);

          setLocalTime(event.target.value);
          scrollToTime(event.target.value, setHighlightedIndex);
        },
        endAdornment: showArrow && React__default["default"].createElement(InputAdornment["default"], {
          position: "end"
        }, React__default["default"].createElement(ArrowDropdown, {
          onClick: openMenu,
          className: arrow
        }))
      }),
      InputLabelProps: getLabelProps(),
      disabled: disabled
    }), React__default["default"].createElement(PopperComponent, _extends["default"]({}, enablePortal && popperComponentProps, getMenuProps(undefined, {
      suppressRefError: true
    })), isOpen && React__default["default"].createElement(Paper, {
      id: 'scrolling_div',
      className: paper,
      square: true
    }, timeWindows({
      inputValue: inputValue,
      getItemProps: getItemProps,
      highlightedIndex: highlightedIndex,
      selectedItem: selectedItem
    }))));
  });
};

TimeSelectorTextsField.defaultProps = {
  onChange: function onChange(time) {
    return undefined;
  },
  dateError: false,
  enablePortal: false,
  margin: 'superdense',
  disableUnderline: true,
  disabled: false,
  showArrow: false
};

module.exports = TimeSelectorTextsField;
